import { productIdFormat } from "@redotech/redo-product-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const ProductInventoryPushFailureReasonSchema = z.enum([
  "stale",
  "push_failed",
]);
export type ProductInventoryPushFailureReason = z.infer<
  typeof ProductInventoryPushFailureReasonSchema
>;

const PushProductInventoryResultSchema_ = z.discriminatedUnion("status", [
  z.object({
    status: z.literal("pushed"),
    pushedCount: z.number(),
    skippedCount: z.number(),
  }),
  z.object({ status: z.literal("disabled") }),
  z.object({ status: z.literal("running") }),
  z.object({
    status: z.literal("failed"),
    reason: ProductInventoryPushFailureReasonSchema,
    ageSeconds: z.number().nullable(),
  }),
]);
export const PushProductInventoryResultSchema: z.ZodType<PushProductInventoryResult> =
  PushProductInventoryResultSchema_;
export type PushProductInventoryResult = {} & z.infer<
  typeof PushProductInventoryResultSchema_
>;

export const pushProductInventory = unaryRpc({
  name: "pushProductInventory",
  input: z.object({ productId: productIdFormat.schema }),
  output: PushProductInventoryResultSchema,
});
